
import { Component, HostListener, OnInit, NgZone  } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { CustomLoaderService } from '../services/custom-loader.service';
import { MainHeaderMenuService } from '../services/main-header-menu.service';
import { EncrdecrService } from './../Auth/encrdecr.service';
import { LoginService } from '../services/login.service';
import { ClientDataService } from '../services/client-data.service';
import { environment } from 'src/environments/environment';
import { ProfileService } from 'src/app/services/profile.service';
import { isEmailValidate, isNullOrUndefined, IsValidMobile, IsValidOTP } from '../validation';
import { CleverTapUtilityService } from 'src/app/services/clever-tap-utility.service';
declare var $: any;
declare var google: any;


@Component({
  selector: 'app-emp-login',
  templateUrl: './emp-login.component.html',
  styleUrls: ['./emp-login.component.scss']
})
export class EmpLoginComponent {

  IsInvestor: boolean = false;
  LoginForm: FormGroup;
  LoginSubmitted: boolean = false;
  UserType: number = 1;
  IsShowLoginOption: boolean = true;
  WelcomeText: any = '';
  CompanyName: string = '';
  logo: string;
  NavHeight: string;
  IsMobile: boolean = false;
  logoWidth: string;
  logoHeight: string;
  MobileLoginForm: FormGroup;
  isMobileLoginFormSubbmitted: boolean = false;
  isMobileListDisplay: boolean = false;
  CurrentCompanyName: string = environment.CompayName;
  EmailLoginForm: FormGroup;
  isEmailFormSubbmitted: boolean = false;
  isEmailListDisplay: boolean = false;
  ClientData: any = [];
  ClientDataBasedOnEmail: any = [];
  characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  redirect_fd: any;
  redirect_mf: any;
  redirect_nfo: any;
  redirect_preferscheme: any;
  redirectTo: string = "";
  TakeMeToPage: string = "/dashboard";
  USERLoginId: any;
  Token: any;
  PageURL: string;
  PageView: boolean = false; // display employee page or not
  IsFromDeepLink: boolean = false;
  googleUser: any = null;

  constructor(private LoginService: LoginService,
    private EncrdecrService: EncrdecrService,
    public ShowHideHeaderMenu: MainHeaderMenuService,
    private formBuilder: FormBuilder, private router: Router, private route: ActivatedRoute, private Loader: CustomLoaderService,
    private ClientDataService: ClientDataService,private clientProfileService: ProfileService,private Clevertap:CleverTapUtilityService,
    private ngZone: NgZone) {
    this.LoginForm = this.formBuilder.group({
      Username: ['', Validators.required],
      Password: ['', [Validators.required]],
      UserType: ['1']
    });
    this.MobileLoginForm = this.formBuilder.group({
      Mobile: ['', [Validators.required, Validators.pattern(IsValidMobile)]],
      MobileOTP: ['', [Validators.required, Validators.pattern(IsValidOTP)]],
    });

    this.EmailLoginForm = this.formBuilder.group({
      Email: ['', [Validators.required, Validators.pattern(isEmailValidate)]],
      EmailOTP: ['', [Validators.required, Validators.pattern(IsValidOTP)]],
    });
  }
  SetViewPort(w) {
    if (w <= 767) {
      this.IsMobile = true;
    }
    else {
      this.IsMobile = false;
    }
  }
  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.SetViewPort(event.target.innerWidth)
  }
  ngOnInit() {
    this.loadGoogleSignIn();
    //Added by Dalsukh (SSO Verification Module)
    this.route.queryParams.subscribe(params => {

      // console.log("Params",params);
      this.Loader.show();
      let parameters = params.dplk; 
      if(!isNullOrUndefined(parameters) && parameters != "" && parameters != "0"){
        let Param = parameters.replace(/ /g, "+");
        console.log(" value ->", Param);
        sessionStorage.setItem('OPHqexF834YT4HhjG8', Param); //  DeepLinkId
        this.IsFromDeepLink = true;
      }
      else{
        this.IsFromDeepLink = false;
      }
      this.Token = params['Data'];
      if (this.Token) {
        this.PageView = true;
        this.Loader.show()
        debugger
        this.LoginForm.controls["Username"].setValue(this.EncrdecrService.getDecr(sessionStorage.getItem('1rMWoq/fR0KsYA9AxL63Cw=='))); // Userid
        this.LoginForm.controls["Password"].setValue(this.EncrdecrService.getDecr(sessionStorage.getItem('HNrvPKl2xEC1ZGyPqCxAOQ=='))); //Password
        this.PageURL = this.EncrdecrService.getDecr(sessionStorage.getItem('+TrzWUXUJ0Cd20+J77gj4A==')) //Page URL
        this.onSubmit()
      }

    });
    //Ended by Dalsukh (SSO Verification Module)

    this.SetViewPort(window.innerWidth);
    this.getCompanyDetails();
    sessionStorage.setItem("nvjsd212djskd$#21ksdj", "E")
    this.WelcomeText = this.ClientDataService.GetWelcomeText();
    this.logo = sessionStorage.getItem('logo');
    this.CompanyName = this.ClientDataService.GetCompanyName();
    // if (this.CompanyName == 'Mahindra') {
    //   this.logoWidth = '330px';
    //   this.logoHeight = '120px';
    //   this.NavHeight = '40px';
    //   $('.MainOuter').css('min-height', window.innerHeight - 70);
    // }
    // else if (this.CompanyName == 'AU') {
    //   this.logoWidth = '130px';
    //   this.logoHeight = '60px';
    //   this.NavHeight = '62px';
    //   $('.MainOuter').css('min-height', window.innerHeight - 0);
    //   $('.LoginOuter').css('min-height', '100vh');
    // }
    // else if (this.CompanyName == 'YesSecurities') {
    //   this.logoWidth = '150px';
    //   this.logoHeight = '60px';
    //   this.NavHeight = '62px';
    //   $('.MainOuter').css('min-height', window.innerHeight - 75);
    // }

    const CorporateFag = sessionStorage.getItem('Vbhs@#%LMKIo=');
    if (CorporateFag == 'C') {

      //this.ShowHideHeaderMenu.hide();
      sessionStorage.removeItem('F44sGAGh2xwkpUL');//Session_SubBrokerId
      sessionStorage.removeItem('Hldq31TLYwRbLJ8');//Session_SubBrokerCode
      sessionStorage.removeItem('UZT6qHaDZSz66kx'); //Session_ClientBasicInfoId
      sessionStorage.removeItem('N1QJHdOkO7Hz8QC'); //Session_ClientBasicInfoId
      sessionStorage.removeItem('L2D3506kIHSk3E0'); //Session_UserType
      sessionStorage.removeItem('pOWgAF62qFXnZMn'); // Session_Razor
      sessionStorage.removeItem('W113TKilrF1u1gL'); // ucc code - client
      sessionStorage.removeItem('`huR,8@RK9^??b4 -.hfs!!uR,XX');
      sessionStorage.removeItem('nbj%98LS74nkjsn~@&4njrkd`!kd*294');
      sessionStorage.removeItem('hn0bHyGhfpGtrPe'); //family id
      sessionStorage.removeItem('E#$%#XCha7%*=');
      sessionStorage.removeItem('Vbhs@#%LMKIo=');

    }
    else {
      this.router.parseUrl("**");
    }
  }
  get r() {
    return this.LoginForm.controls;
  }

  get j() {
    return this.MobileLoginForm.controls;
  }

  get e() {
    return this.EmailLoginForm.controls;
  }

  isNumber(evt) {
    evt = (evt) ? evt : window.event;
    var charCode = (evt.which) ? evt.which : evt.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  loadGoogleSignIn(): void {
    debugger;
    const interval = setInterval(() => {
      if (typeof google !== 'undefined' && google.accounts) {
        clearInterval(interval);
        this.initializeGoogle();
      }
    }, 100);
  }

  initializeGoogle(): void {
    google.accounts.id.initialize({
      client_id: environment.GoogleclientId,
      callback: (response: any) => {
        this.ngZone.run(() => {
          this.handleGoogleResponse(response);
        });
      }
    });
  }

  signInWithGoogle(): void {
    debugger;
    google.accounts.oauth2.initTokenClient({
      client_id: environment.GoogleclientId,
      scope: 'email profile openid',
      callback: (tokenResponse: any) => {
        this.ngZone.run(() => {
          if (tokenResponse && tokenResponse.access_token) {
            this.fetchGoogleUserInfo(tokenResponse.access_token);
          }
        });
      }
    }).requestAccessToken(); 
  }

  fetchGoogleUserInfo(accessToken: string): void {
    fetch('https://www.googleapis.com/oauth2/v3/userinfo', {
      headers: { Authorization: `Bearer ${accessToken}` }
    })
    .then(res => res.json())
    .then(userInfo => {
      this.ngZone.run(() => {
        if( userInfo && userInfo.email){
          this.googleUser = userInfo;
          let password = this.EncrdecrService.getDecr(environment.Password)
          const json = {
            "Username": userInfo.email,
            "Password": password
          }
          let databody = JSON.stringify(json);
          this.callAuthenticationController(databody)
        }else{
            this.CallAlertModal("Sign In With Google Failed!")
        }
      });
    })
    .catch(err => console.error('Failed to fetch user info:', err));
  }

  handleGoogleResponse(response: any): void {
    console.log('JWT Token:', response.credential);
    const userInfo = this.decodeJwt(response.credential);
    console.log('User:', userInfo);
  }

  decodeJwt(token: string): any {
    try {
      const base64 = token.split('.')[1];
      const decoded = atob(base64);
      return JSON.parse(decoded);
    } catch (e) {
      console.error('JWT decode error:', e);
      return null;
    }
  }

  SendOtpToEmail() {

    let Email = this.EmailLoginForm.controls["Email"].value;
    if (Email == "") {
      this.CallAlertModal("Please enter email address.")
    } else {
      var pattern = new RegExp(isEmailValidate);
      var result = pattern.test(Email);
      if (result == true) {
        const EmailRequest = {
          "USER_TYPE": '2',
          "VERIFICATION_ID": 'IFDEmailOTPLogin',
          "FullName": this.EmailLoginForm.controls["Email"].value,
          "EmailId": this.EmailLoginForm.controls["Email"].value,
          "Trans_Type": 'EmailID',
          "Flag": "G"
        }
        var json = JSON.stringify(EmailRequest);
        this.SendEmailOTP(json);
      } else {
        this.CallAlertModal("Invalid Email Address")
        this.EmailLoginForm.reset();
      }
    }
  }

  onClickReSendEmailOTP() {

    let Email = this.EmailLoginForm.controls["Email"].value;
    if (Email == "") {
      this.CallAlertModal("Please enter email address.")
    } else {
      var pattern = new RegExp(isEmailValidate);
      var result = pattern.test(Email);
      if (result == true) {
        this.Loader.show();
        const EmailRequest = {
          "USER_TYPE": '2',
          "VERIFICATION_ID": 'IFDEmailOTPLogin',
          "FullName": this.EmailLoginForm.controls["Email"].value,
          "EmailId": this.EmailLoginForm.controls["Email"].value,
          "Trans_Type": 'EmailID',
          "Flag": "G"
        }
        var json = JSON.stringify(EmailRequest);
        this.SendEmailOTP(json);
      } else {
        this.CallAlertModal("Invalid Email Address")
        this.EmailLoginForm.reset();
      }
    }
  }

  OnClickReSendButton() {
    let mobile = this.MobileLoginForm.controls["Mobile"].value;
    if (mobile == "") {
      this.CallAlertModal("please Enter Mobile number !!")
    } else {
      if (mobile.length == 10) {
        var pattern = new RegExp(IsValidMobile);
        var result = pattern.test(mobile);
        if (result == true) {
          this.Loader.show();
          const request = {
            "USER_TYPE": '2',
            "VERIFICATION_ID": 'IFDMobileOTPLogin',
            "FullName": "",
            "MobileNo": this.MobileLoginForm.controls["Mobile"].value,
            "Trans_Type": "Mobile",
            "Flag": "G",
          };
          var json = JSON.stringify(request);
          this.SendMobileOTP(json);
        } else {
          this.CallAlertModal("invalid Mobile number !!")
          this.MobileLoginForm.reset();
        }
      } else {
        this.CallAlertModal("invalid Mobile number !!")
        this.MobileLoginForm.reset();
      }
    }
  }

  SendOtpToMobile() {

    let mobile = this.MobileLoginForm.controls["Mobile"].value;
    if (mobile.length == 10) {
      var pattern = new RegExp(IsValidMobile);
      var result = pattern.test(mobile);
      if (result == true) {
        this.Loader.show();
        const request = {
          "USER_TYPE": '2',
          "VERIFICATION_ID": 'IFDMobileOTPLogin',
          "FullName": "",
          "MobileNo": this.MobileLoginForm.controls["Mobile"].value,
          "Trans_Type": "Mobile",
          "Flag": "G",
        };
        var json = JSON.stringify(request);
        this.SendMobileOTP(json);
      } else {
        this.CallAlertModal("Invalid Mobile number");
        this.MobileLoginForm.reset();
      }
    } else {
      this.CallAlertModal("Invalid Mobile number");
      this.MobileLoginForm.reset();
    }

  }

  SendMobileOTP(request: any) {
    this.LoginService.JMOTPMobile(request).subscribe(
      (response: any) => {
        let res = JSON.parse(this.EncrdecrService.getDecr(response))

        this.Loader.hide();
        if (res.Message == "Success") {
          this.CallAlertModal("OTP sent to your mobile no...")
        } else if (res.Message == "Overlimit") {
          this.CallAlertModal("Overlimit")
        } else {
          this.CallAlertModal("OTP operation Faild...")
        }
      }, (err: any) => {
        console.log(err);
      })
  }

  SendEmailOTP(EmailRequest: any) {
    this.LoginService.JMOTPEmail(EmailRequest).subscribe(
      (response: any) => {
        let res = JSON.parse(this.EncrdecrService.getDecr(response))

        this.Loader.hide();
        if (res.Message == "Success") {
          this.CallAlertModal("OTP sent to your EmailID...")
        } else if (res.Message == "Overlimit") {
          this.CallAlertModal("Overlimit")
          this.EmailLoginForm.reset();
        } else {
          this.CallAlertModal("OTP operation Faild...")
          this.EmailLoginForm.reset();
        }
      }, (err: any) => {
        console.log(err);
      })
  }

  OnMobileLogin() {

    let RandomKey = "";
    RandomKey = this.generateRandomString(6)
    this.isMobileLoginFormSubbmitted = true;
    if (this.MobileLoginForm.invalid) {
      return
    } else {
      this.Loader.show();
      const MobileVerifyRequest = {
        "FullName": "Chirag Dhruv",
        "MobileNo": this.MobileLoginForm.controls["Mobile"].value,
        "Trans_Type": "Mobile",
        "Flag": "V",
        "OTP": this.MobileLoginForm.controls["MobileOTP"].value,
        "RandomKey": RandomKey
      };
      var json = JSON.stringify(MobileVerifyRequest);
      this.LoginService.JMOTPMobile(json).subscribe(
        (response: any) => {
          let key = ''
          let message = ''
          let res = JSON.parse(this.EncrdecrService.getDecr(response))
          key = res.Message.split('|')[0]
          message = res.Message.split('|')[1]

          if (message == "Verified" && key == RandomKey) {
            this.Loader.hide();
            this.CallAlertModal("OTP Verified Successfully");
            const json = {
              "MobileNo": this.MobileLoginForm.controls["Mobile"].value,
              "Email": "",
              "flag": "BasedOnMobile",
              "UserType": this.UserType
            }
            let data = JSON.stringify(json)
            this.Loader.show();
            this.LoginService.fetchSubBrokerDetailsBasedOnMobile(data).subscribe(
              (response: any) => {
                let result = JSON.parse(this.EncrdecrService.getDecr(response))
                if (result.ArrayOfResponse != null && result.ArrayOfResponse != undefined) {
                  console.log(result.ArrayOfResponse);
                  ;
                  this.Loader.hide();
                  //if(result.ArrayOfResponse.length === 1 || result.ArrayOfResponse.length >= 1){
                  if (result.ArrayOfResponse.length === 1) {
                    let password = this.EncrdecrService.getDecr(result.ArrayOfResponse[0].Password)
                    console.log(password);
                    const json = {
                      "Username": result.ArrayOfResponse[0].SubBrokerCode,
                      "Password": password
                    }
                    let databody = JSON.stringify(json);
                    this.callAuthenticationController(databody)
                  } else {
                    if (result.ArrayOfResponse.length === 0) {
                      this.CallAlertModal("unauthorized user Sorry..please contact Branch.");
                      this.MobileLoginForm.reset();
                    } else {
                      this.Loader.hide();
                      this.ClientData = result.ArrayOfResponse
                      this.isMobileListDisplay = true;
                      $('#AlertModal').modal('hide');
                      $('#AlertModalLogin').modal({
                        backdrop: 'static',
                        keyboard: false
                      });
                    }
                  }
                }
              }), (err: any) => {
                console.log(err);
                this.Loader.hide();
              }
          } else if (res.Message == "OTP Code is Expired") {
            this.Loader.hide();
            this.CallAlertModal("OTP Code is Expired")
            this.MobileLoginForm.reset();
          } else if (res.Message == "User Not Exist") {
            this.Loader.hide();
            this.CallAlertModal(res.Message);
            this.MobileLoginForm.reset();
            this.isMobileListDisplay = false;
          } else if (res.Message == "Overlimit") {
            this.Loader.hide();
            this.CallAlertModal("Overlimit!! please try after 5 minutes.");
            this.MobileLoginForm.reset();
            this.isMobileListDisplay = false;
          } else if (res.Message == "Invalid OTP Code") {
            this.Loader.hide();
            this.CallAlertModal("Invalid OTP Code");
            this.MobileLoginForm.reset();
            this.isMobileListDisplay = false;
          } else {
            this.Loader.hide();
            this.CallAlertModal("Verified operation Faild...")
            this.MobileLoginForm.reset();
            this.isMobileListDisplay = false;
          }
        })
        , (err: any) => {
          console.log(err)
          this.Loader.hide();
        }
    }
  }

  onEmailLoginClick() {
    this.isEmailFormSubbmitted = true;
    let RandomKey = "";
    RandomKey = this.generateRandomString(6)
    if (this.EmailLoginForm.invalid) {
      return
    } else {
      this.Loader.show();
      let Email = this.EmailLoginForm.controls["Email"].value;
      const EmailVerifyRequest = {
        "FullName": "",
        "EmailId": this.EmailLoginForm.controls["Email"].value,
        "Trans_Type": "EmailID",
        "Flag": "V",
        "OTP": this.EmailLoginForm.controls["EmailOTP"].value,
        "RandomKey": RandomKey
      };
      var json = JSON.stringify(EmailVerifyRequest);
      this.LoginService.JMOTPEmail(json).subscribe(
        (response: any) => {
          let key = ''
          let message = ''
          let res = JSON.parse(this.EncrdecrService.getDecr(response))

          key = res.Message.split('|')[0]
          message = res.Message.split('|')[1]
          this.Loader.hide();
          if (message == "Verified" && key == RandomKey) {
            this.CallAlertModal("OTP Verified Successfully");
            const json = {
              "MobileNo": "",
              "Email": this.EmailLoginForm.controls["Email"].value,
              "flag": "BasedOnEmail",
              "UserType": this.UserType
            }
            this.Loader.show();
            let data = JSON.stringify(json)
            this.LoginService.fetchSubBrokerDetailsBasedOnMobile(data).subscribe(
              (response: any) => {
                let res = JSON.parse(this.EncrdecrService.getDecr(response))
                this.Loader.hide();
                if (res.ArrayOfResponse != null && res.ArrayOfResponse != undefined) {
                  // if(res.ArrayOfResponse.length === 1 || res.ArrayOfResponse.length >= 1){
                  if (res.ArrayOfResponse.length === 1) {
                    let password = this.EncrdecrService.getDecr(res.ArrayOfResponse[0].Password)
                    const json = {
                      "Username": res.ArrayOfResponse[0].SubBrokerCode,
                      "Password": password
                    }
                    let databody = JSON.stringify(json);
                    this.callAuthenticationController(databody)
                  } else {
                    if (res.ArrayOfResponse.length === 0) {
                      this.CallAlertModal("unauthorized user Sorry contact Branch.");
                      this.EmailLoginForm.reset();
                    } else {
                      this.Loader.hide();
                      this.ClientDataBasedOnEmail = res.ArrayOfResponse;
                      this.isEmailListDisplay = true;
                      $('#AlertModal').modal('hide');
                      $('#AlertModalLoginEmail').modal({
                        backdrop: 'static',
                        keyboard: false
                      });
                    }
                  }
                }
              }, (err: any) => {
                console.log(err);
                this.Loader.hide();
              })
          } else if (res.Message == "OTP Code is Expired") {
            this.CallAlertModal("OTP Code is Expired")
            this.EmailLoginForm.reset();
          } else if (res.Message == "User Not Exist") {
            this.CallAlertModal(res.Message);
            this.EmailLoginForm.reset();
            this.isEmailListDisplay = false;
          } else if (res.Message == "Overlimit") {
            this.CallAlertModal("Overlimit!! please try after 5 minutes.");
            this.EmailLoginForm.reset();
            this.isEmailListDisplay = false;
          } else if (res.Message == "Invalid OTP Code") {
            this.CallAlertModal("Invalid OTP Code");
            this.EmailLoginForm.reset();
            this.isEmailListDisplay = false;
          } else {
            this.CallAlertModal("Verified operation Faild...")
            this.EmailLoginForm.reset();
            this.isEmailListDisplay = false;
          }
        }, (err: any) => {
          console.log(err);
          this.Loader.hide();
        })
    }
  }

  OnClickClientSelection(clientDetails: any) {
    if (clientDetails != undefined && clientDetails != null) {
      this.Loader.show();
      let password = this.EncrdecrService.getDecr(clientDetails.Password)
      const json = {
        "Username": clientDetails.SubBrokerCode,
        "Password": password
      }
      let databody = JSON.stringify(json);
      this.callAuthenticationController(databody)
    } else {
      this.CallAlertModal("Something goes Wrong");
    }
  }

  BasedonEmailSelection(clientDetails: any) {
    if (clientDetails != undefined && clientDetails != null) {
      this.Loader.show();
      let password = this.EncrdecrService.getDecr(clientDetails.Password)
      const json = {
        "Username": clientDetails.SubBrokerCode,
        "Password": password
      }
      let databody = JSON.stringify(json);
      this.callAuthenticationController(databody)
    } else {
      this.CallAlertModal("Something goes Wrong");
    }
  }


  onSubmitMain(IPADD:string = '') {

    this.LoginSubmitted = true;

    //Condition by Dalsukh for sso login without password
    if (this.LoginForm.invalid && !(!isNullOrUndefined(sessionStorage.getItem("1rMWoq/fR0KsYA9AxL63Cw==")) && !isNullOrUndefined(sessionStorage.getItem("HNrvPKl2xEC1ZGyPqCxAOQ==")) && !isNullOrUndefined(sessionStorage.getItem("+TrzWUXUJ0Cd20+J77gj4A==")))) {
      return;
    }
    else {

      sessionStorage.setItem('HNrvPKl2xererertyCxAOQ==', this.EncrdecrService.setEncr(this.LoginForm.controls["Password"].value))
      //////
      //alert("Login Successfully");
      this.Loader.show()
      let DataBody = JSON.stringify(this.LoginForm.value);
      // sessionStorage.setItem('Tgsh@#3734fjfskshh==', '173.212.234.56');
      sessionStorage.setItem('Tgsh@#3734fjfskshh==', IPADD);
      let IpAddress = sessionStorage.getItem('Tgsh@#3734fjfskshh==');
      let LoginSource = "";

      //taking sso flag based on sso login or noraml login based on session storage
      if (!isNullOrUndefined(sessionStorage.getItem("1rMWoq/fR0KsYA9AxL63Cw==")) && !isNullOrUndefined(sessionStorage.getItem("HNrvPKl2xEC1ZGyPqCxAOQ==")) && !isNullOrUndefined(sessionStorage.getItem("+TrzWUXUJ0Cd20+J77gj4A=="))) {
        LoginSource = "SSO";
      }
      this.LoginService.Post_EmployeeLogin(DataBody, this.UserType, IpAddress, LoginSource).then(
        (res1: any) => {
          let res = JSON.parse(this.EncrdecrService.getDecr(res1));
          console.log(res);


          if (res != "Invalid Username and Password") {
            sessionStorage.setItem('5V5uSYBoBVqAvBIBqUEBhv6ELFF', this.EncrdecrService.setEncr("1"));
            sessionStorage.setItem('`huR,8@RK9^??b4 -.hfs!!uR,XX', res.TOKEN_ID);
            sessionStorage.setItem('F44sGAGh2xwkpUL', res.LOGIN_ID); // Session_SubBrokerId
            sessionStorage.setItem('V4WGROuLLBE6t98', res.USER_NAME); // Session_UserName
            sessionStorage.setItem('V8hpPfITcxhEI9x', res.EMAIL_ID); // Session_UserEmail
            sessionStorage.setItem('Xe003SRRyYEoOC2', res.MOBILE); // Session_UserMobile
            sessionStorage.setItem('qWHWUPDdjECflTMalUPo9w',res.isCDR); //Added by Tishya for getting isCDR for Employee Login
            console.log("IsCDR = ",res.isCDR);
            //let login_id = this.EncrdecrService.getDecr(res.LOGIN_ID)
            //let SubBrokerCode = this.EncrdecrService.getDecr(res.SubBrokerCode); getting null
            //USER_ID = this.EncrdecrService.getDecr(res.USER_ID)

            if (res.RazorCustId !== null && res.RazorCustId !== undefined && res.RazorCustId !== 'null') {
              sessionStorage.setItem('pOWgAF62qFXnZMn', res.RazorCustId); // RazorCustId
            } else {
              sessionStorage.setItem('pOWgAF62qFXnZMn', ''); // RazorCustId
            }
            sessionStorage.setItem('Hldq31TLYwRbLJ8', res.SubBrokerCode); /// Session_SubBrokerCode
            sessionStorage.setItem('L2D3506kIHSk3E0', res.USER_TYPE); // Session_UserType
            sessionStorage.setItem('qAkZrQYLWNBSlki', res.LOGIN_ID); // Session_CBId
            //#region
            sessionStorage.setItem('pi4ZU2P3M8JE4q7', ''); // Session_B64CompanyLogo
            //#endregion
            // sessionStorage.setItem('Session_B64CompanyLogo_EtE',res.Companylogobase64);
            if (res.Family_ID !== null && res.Family_ID !== undefined && res.Family_ID !== 'null') {
              sessionStorage.setItem('hn0bHyGhfpGtrPe', res.Family_ID);  // Session_Family_ID
            }
            switch (this.EncrdecrService.getDecr(res.USER_TYPE)) {
              case '1':
                this.Loader.hide();
                sessionStorage.setItem('m5JkoXISmYRAIuY', res.USER_ID); // Session_UserId

                this.USERLoginId = res.USER_ID;
                sessionStorage.setItem('5gE4QWzFXWKewRC', res.ROLEID); // Role_ID

                if (this.EncrdecrService.getDecr(res.ROLEID) == "1")
                  sessionStorage.setItem('sdg257561gds', "1"); // for Pan searching functionality
                sessionStorage.setItem('dsfagzvxctwre', this.EncrdecrService.setEncr("portfolio"));
                // sessionStorage.setItem('nbj%98LS74nkjsn~@&4njrkd`!kd*294', res.RazorePaymentStatus)
                // this.router.navigate(['/payment'], { relativeTo: this.route };

                sessionStorage.setItem('nbj%98LS74nkjsn~@&4njrkd`!kd*294', 'res.RazorePaymentStatus');

// Added by Tishya for IIFL-2030
let rr1 = '',rr2 = '',rr3 = '',rr4 = '' 
let r1 = sessionStorage.getItem('m5JkoXISmYRAIuY'); //Session UserId
let r2 = sessionStorage.getItem('L2D3506kIHSk3E0'); //Session UserType
let r3 = sessionStorage.getItem('V8hpPfITcxhEI9x'); //Session EmailId
let r4 = sessionStorage.getItem('Xe003SRRyYEoOC2'); //Session UserMobile

if(r1){
  rr1 = this.EncrdecrService.getDecr(r1);
}
if(r2){
  rr2 = this.EncrdecrService.getDecr(r2);
}
if(r3){
  rr3 = this.EncrdecrService.getDecr(r3);
}
if(r4){
  rr4 = this.EncrdecrService.getDecr(r4);
  if(rr4!="")
  {
    rr4 = rr4.includes('+91') ? rr4.replace(/\s+/g, '') : `+91${rr4.trim()}`
  }
}

let UserInfo = {
  "Site":{
    "Identity":rr1,
    "UserType":rr2,
    "Email":rr3,
    "Phone":rr4
  }
}
// alert(JSON.stringify(UserInfo))
this.Clevertap.userLoginEvent(UserInfo);  

                //Added by Dalsukh SSO verification Module
                if (!isNullOrUndefined(sessionStorage.getItem("1rMWoq/fR0KsYA9AxL63Cw==")) && !isNullOrUndefined(sessionStorage.getItem("HNrvPKl2xEC1ZGyPqCxAOQ==")) && !isNullOrUndefined(sessionStorage.getItem("+TrzWUXUJ0Cd20+J77gj4A=="))) {
                  this.Loader.hide();
                  sessionStorage.removeItem('1rMWoq/fR0KsYA9AxL63Cw==');
                  sessionStorage.removeItem('HNrvPKl2xEC1ZGyPqCxAOQ==');
                  sessionStorage.removeItem('+TrzWUXUJ0Cd20+J77gj4A==');
                  //this.router.navigateByUrl("/" + this.PageURL);
                  window.location.href = "/" + this.PageURL;
                  return;

                }
                //Ended by Dalsukh SSO verification Module

                //
                if(this.IsFromDeepLink){
                  window.location.href = '/deeplink-redirector';
                }
                else{
                  if (this.EncrdecrService.getDecr(res.ROLEID) != "10") {
                    window.location.href = this.TakeMeToPage || '/dashboard';
                  }
                  else {
                    window.location.href = '/reports-new/brops-dashboard';
                  }
                }



                // this.router.navigate(["/dashboard"], {
                //   relativeTo: this.route,
                // });

                break;
            }
                          //Microsoft Clarity Code Starts
            let id = this.USERLoginId;

            if (id != null && id != undefined && id != '') {
              id = this.EncrdecrService.getDecr(id);
              sessionStorage.removeItem('cl2342wrty'); ///21062024
              sessionStorage.setItem('cl2342wrty', id)
            }

            setTimeout(() => {
              $("#addedScript").remove();
              var head = document.getElementsByTagName('head')[0];
              var script = document.createElement('script');
              script.type = 'text/javascript';
              script.setAttribute('id', 'addedScript');
              script.text = `
                 debugger
                 let clid = sessionStorage.getItem('cl2342wrty')
                 let currentUserId = '0' ;
                 if(clid != null && clid != undefined && clid != ''){
                     currentUserId = clid;
                 }

                 (function(c,l,a,r,i,t,y){
                   c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
                   t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
                   y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
                   clarity("set", "userId", currentUserId.toString());
                   console.log(currentUserId.toString())
               })(window, document, "clarity", "script", "myvdl8jnsv");
                 `
              head.appendChild(script);
            }, 500);
            //Microsoft Clarity Code Ends
          }
          else {
            this.Loader.hide();
            this.CallAlertModal('Please enter valid username and password');
          }
        },
        (err: any) => {
          // //////
          // console.log(err)
          const rr = err.error;
          const er = rr.substring(1, rr.length - 1);
          const rk = er.split(', ');
          this.Loader.hide();
          if (rk[1].includes('Number of invalid login attempts')) {
            this.CallAlertModal('Number of invalid login attempts. Your account is locked for 15 minutes');
          } else {
            this.CallAlertModal('Please enter valid username and password');
          }
          //// console.log('err =>' + er);
        }

      );

    }
  }

  onSubmit(){
    this.clientProfileService.getIPAddress().subscribe((res:any)=>{  
      debugger
      let ipAddress=res.ip;
      this.onSubmitMain(ipAddress);
    },
    error => {
      this.onSubmitMain("");
    })
  }

  SendUserType() {
    //////
    sessionStorage.setItem('L2D3506kIHSk3E0', this.EncrdecrService.setEncr(this.UserType.toString()));
  }
  CallAlertModal(msg: any) {
    $("#AlertModal").modal({
      backdrop: 'static',
      keyboard: false
    });
    $('#AlertModalContent').text(msg);
  }
  getCompanyDetails() {
    this.ClientDataService.getCompanyDetails(environment.CompanyId).subscribe((data: any) => {
      this.Loader.hide();
      if (data != null && data.ArrayOfResponse.length != 0) {
        let rk = data.ArrayOfResponse[0];
        console.log('Corp_IFA = ' + this.EncrdecrService.getDecr(rk.Dummy1));
        //this.Companyname = rk.CompanyName;
        if (this.ClientDataService.GetCompanyName() == 'AU') {
          sessionStorage.setItem('Abodhj#@jdkd/%^82ncdbcnggshd!@#$', this.EncrdecrService.setEncr("4"));
          sessionStorage.setItem('Mnuoisns6wqgswj2$#', "1");
        }
        else if (this.ClientDataService.GetCompanyName() == 'Mahindra') {
          sessionStorage.setItem('Abodhj#@jdkd/%^82ncdbcnggshd!@#$', this.EncrdecrService.setEncr("2"));
          sessionStorage.setItem('Mnuoisns6wqgswj2$#', "0");
        }
        else if (this.ClientDataService.GetCompanyName() == 'YesSecurities') {
          sessionStorage.setItem('Abodhj#@jdkd/%^82ncdbcnggshd!@#$', this.EncrdecrService.setEncr("11"));
          sessionStorage.setItem('Mnuoisns6wqgswj2$#', "0");
        }
        else {
          sessionStorage.setItem('Abodhj#@jdkd/%^82ncdbcnggshd!@#$', this.EncrdecrService.setEncr("0"));
          sessionStorage.setItem('Mnuoisns6wqgswj2$#', "0");
        }

        sessionStorage.setItem('E#$%#XCha7%*=', this.EncrdecrService.getDecr(rk.Dummy2));
        sessionStorage.setItem('Vbhs@#%LMKIo=', this.EncrdecrService.getDecr(rk.Dummy1));
        sessionStorage.setItem('DufjGDH3843JE', this.EncrdecrService.getDecr(rk.Dummy4));
        sessionStorage.setItem('PfdkSJDNWks2323Ms', this.EncrdecrService.getDecr(rk.Dummy3));
        sessionStorage.setItem('Arh34SDBJSSiF', this.EncrdecrService.getDecr(rk.Dummy5));
        sessionStorage.setItem('Fhd63asja$%Wsdjs9304#@dfvdjfjd', this.EncrdecrService.getDecr(rk.Dummy6));

        sessionStorage.setItem('%^&s8g9b!@fla%g', this.EncrdecrService.getDecr(rk.Dummy7));
        if (!isNullOrUndefined(this.EncrdecrService.getDecr(rk.Dummy10))) {
          sessionStorage.setItem('dsa&hdhbc%ube=', this.EncrdecrService.getDecr(rk.Dummy10));
        } else {
          sessionStorage.setItem('dsa&hdhbc%ube=', 'false');
        }

        if (!isNullOrUndefined(rk.EnableRiskProfile)) {
          sessionStorage.setItem('cIe+MhBUozWO3+mKZd2to=', this.EncrdecrService.getDecr(rk.EnableRiskProfile)); //Y or N
        }
        else {
          sessionStorage.setItem('cIe+MhBUozWO3+mKZd2to=', 'n');
        }



        // sessionStorage.setItem('cIe+MhBUozWO3+mKZd2to=', this.EncrdecrService.getDecr(rk.EnableRiskProfile));
      }
    });
  }

  callAuthenticationController(DataBody: any) {

    sessionStorage.setItem('Tgsh@#3734fjfskshh==', '173.212.234.56');
    let IpAddress = sessionStorage.getItem('Tgsh@#3734fjfskshh==');
    this.LoginService.PostLogin_NSE_Info(DataBody, this.UserType, IpAddress).then(
      (res1: any) => {
        let res = JSON.parse(this.EncrdecrService.getDecr(res1));
        console.log('loginResp', res);
        if (res != "Invalid Username and Password") {
          sessionStorage.setItem('5V5uSYBoBVqAvBIBqUEBhv6ELFF', this.EncrdecrService.setEncr("1"));
          sessionStorage.setItem('`huR,8@RK9^??b4 -.hfs!!uR,XX', res.TOKEN_ID);
          sessionStorage.setItem('m5JkoXISmYRAIuY', res.USER_ID);
          sessionStorage.setItem('F44sGAGh2xwkpUL', res.LOGIN_ID); //Session_SubBrokerId
          sessionStorage.setItem('V4WGROuLLBE6t98', res.USER_NAME); //Session_UserName
          sessionStorage.setItem('V8hpPfITcxhEI9x', res.EMAIL_ID); //Session_UserEmail
          sessionStorage.setItem('Xe003SRRyYEoOC2', res.MOBILE); //Session_UserMobile
          if (res.RazorCustId !== null && res.RazorCustId !== undefined && res.RazorCustId !== 'null') {
            sessionStorage.setItem('pOWgAF62qFXnZMn', res.RazorCustId); //RazorCustId
          }
          else {
            sessionStorage.setItem('pOWgAF62qFXnZMn', ''); //RazorCustId
          }
          sessionStorage.setItem('Hldq31TLYwRbLJ8', res.SubBrokerCode); //Session_SubBrokerCode
          sessionStorage.setItem('L2D3506kIHSk3E0', res.USER_TYPE); //Session_UserType
          sessionStorage.setItem('qAkZrQYLWNBSlki', res.LOGIN_ID); //Session_CBId
          sessionStorage.setItem('pi4ZU2P3M8JE4q7', ''); //Session_B64CompanyLogo
          // Added by Tishya for IIFL-2030
          let rr1 = '',rr2 = '',rr3 = '',rr4 = '' 

          let r1 = sessionStorage.getItem('m5JkoXISmYRAIuY'); //Session UserId
          let r2 = sessionStorage.getItem('L2D3506kIHSk3E0'); //Session UserType
          let r3 = sessionStorage.getItem('V8hpPfITcxhEI9x'); //Session EmailId
          let r4 = sessionStorage.getItem('Xe003SRRyYEoOC2'); //Session UserMobile

          if(r1){
            rr1 = this.EncrdecrService.getDecr(r1);
          }
          if(r2){
            rr2 = this.EncrdecrService.getDecr(r2);
          }
          if(r3){
            rr3 = this.EncrdecrService.getDecr(r3);
          }
          if(r4){
            rr4 = this.EncrdecrService.getDecr(r4);
            if(rr4!="")
            {
              rr4 = rr4.includes('+91') ? rr4.replace(/\s+/g, '') : `+91${rr4.trim()}`
            }
          }

          let UserInfo = {
            "Site":{
              "Identity":rr1,
              "UserType":rr2,
              "Email":rr3,
              "Phone":rr4
            }
          }
          // alert(JSON.stringify(UserInfo))
          this.Clevertap.userLoginEvent(UserInfo);
          //sessionStorage.setItem('Session_B64CompanyLogo_EtE',res.Companylogobase64);
          if (res.Family_ID !== null && res.Family_ID !== undefined && res.Family_ID !== 'null') {
            sessionStorage.setItem('hn0bHyGhfpGtrPe', res.Family_ID);  //Session_Family_ID
          }
          switch (this.EncrdecrService.getDecr(res.USER_TYPE)) {
            case '1':
              this.Loader.hide();
              sessionStorage.setItem('m5JkoXISmYRAIuY', res.USER_ID);
              this.USERLoginId = res.USER_ID;
              sessionStorage.setItem('5gE4QWzFXWKewRC', res.ROLEID);
              sessionStorage.setItem('nbj%98LS74nkjsn~@&4njrkd`!kd*294', 'res.RazorePaymentStatus');
              if (this.EncrdecrService.getDecr(res.ROLEID) != "10") {
                window.location.href = this.TakeMeToPage || '/dashboard';
              }
              else {
                window.location.href = '/reports-new/brops-dashboard';
              }
            break;
            case "2":
              sessionStorage.setItem('m5JkoXISmYRAIuY', res.SubBrokerCode); //Session_UserId
              if(this.IsFromDeepLink){
                window.location.href = '/deeplink-redirector';
              }
              else{
                if (res.RazorePaymentStatus) {
                  //this.router.navigate(['/dashboard'], { relativeTo: this.route });
                  window.location.href = this.TakeMeToPage || '/dashboard';
                }
                else {
                  this.Loader.hide();
                  sessionStorage.setItem('nbj%98LS74nkjsn~@&4njrkd`!kd*294', res.RazorePaymentStatus)
                  //this.router.navigate(['/payment'], { relativeTo: this.route });
                  //this.router.navigate(['/dashboard'], { relativeTo: this.route });
                  window.location.href = this.TakeMeToPage || '/dashboard';
                }
              }
              break;


          }
        }
        else {
          this.Loader.hide();
          this.CallAlertModal('Please enter valid username and password');
        }
      },
      (err: any) => {
        ////////
        //console.log(err)
        let rr = err.error;
        let er = rr.substring(1, rr.length - 1);
        let rk = er.split(", ");
        this.Loader.hide();
        if (rk[1].includes('Number of invalid login attempts')) {
          this.CallAlertModal('Number of invalid login attempts. Your account is locked for 15 minutes')
        }
        else {
          this.CallAlertModal('Please enter valid username and password');
        }
        ////console.log('err =>' + er);

      }

    );
  }

  generateRandomString(length) {
    let result = '';
    const charactersLength = this.characters.length;
    for (let i = 0; i < length; i++) {
      result += this.characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }

  RedirectByLink() {
    try {

      var fd_url = ('https://alpha.incredmarkets.com//login-cp?redirect_fd=fd/fd-landing');
      var mf_url = ('https://alpha.incredmarkets.com//login-cp?redirect_mf=transaction-new/lumpsum');
      var nfo_url = ('https://alpha.incredmarkets.com//login-cp?redirect_nfo=explore-funds-new&IsNFO=true');
      var preferscheme_url = ('https://alpha.incredmarkets.com//login-cp?redirect_preferscheme=explore-funds-new&IsPreferred=true');


      this.route.queryParams.subscribe((queryParam) => {
        if (queryParam.redirect_fd != undefined) {
          this.redirect_fd = queryParam.redirect_fd;
          sessionStorage.setItem("sdfetrtr", this.redirect_fd);
        }
      });

      this.route.queryParams.subscribe((queryParam) => {
        if (queryParam.redirect_mf != undefined) {
          this.redirect_mf = queryParam.redirect_mf;
          sessionStorage.setItem("fgrtrytyt", this.redirect_mf);
        }
      });

      this.route.queryParams.subscribe((queryParam) => {
        // 
        if (queryParam.redirect_nfo != undefined) {
          this.redirect_nfo = queryParam.redirect_nfo;
          localStorage.setItem("isnfoyes", this.redirect_nfo);
        }
      });

      this.route.queryParams.subscribe((queryParam) => {

        if (queryParam.redirect_preferscheme != undefined) {
          this.redirect_preferscheme = queryParam.redirect_preferscheme;
          localStorage.setItem("ispreferyes", this.redirect_preferscheme);
        }
      });

      this.route.queryParams.subscribe((queryParam) => {

        if (queryParam.redirectTo != undefined) {
          this.redirectTo = queryParam.redirectTo;
        }
        if (queryParam.flag != undefined) {
          if (queryParam.flag == "NFO") {
            sessionStorage.setItem("Xb5weBH3kMGpXLalI=", "nfo");
          } else if (queryParam.flag == "PrefScheme") {
            sessionStorage.setItem("Xb5weBH3kMGpXLalI=", "ff");
          }
        }
      });
    } catch (error) {
      console.log(error)
    }
  }
 ngAfterViewInit() {
     $(".TakeMeTo_DDl").select2({
      minimumResultsForSearch: -1,
      dropdownCssClass: 'TakeMeTo_Dropdown',
      containerCssClass: 'TakeMeTo_Container'
  });
    $(".TakeMeTo_DDl").on('change', (e: any) => {
      this.TakeMeToPage = $(e.target).val();
    });
  }
}
